import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./Note.css";
import ProfileImage from "Element/ProfileImage";
export default function NoteGhost(props) {
    const className = `note card ${props.className ?? ""}`;
    return (_jsxs("div", { className: className, children: [_jsx("div", { className: "header", children: _jsx(ProfileImage, { pubkey: "" }) }), _jsx("div", { className: "body", children: props.children }), _jsx("div", { className: "footer" })] }));
}
